import RedBullIcon from './redbull.svg';
import MonsterIcon from './monster.svg';

export const SALE_ITEM_ICONS: Record<string, string> = {
    'red bull': RedBullIcon,
    redbull: RedBullIcon,
    monster: MonsterIcon,
    'monster energy': MonsterIcon,
};

export const iconForItem = (name: string): string | null => {
    const key = (name || '').trim().toLowerCase();
    return SALE_ITEM_ICONS[key] ?? null;
};
